import type {
    AdPropertyConfigForFilters,
    ItemsCategoryPropertyFiltersFormValues,
} from '@frontend/modules/public/ads/AdsModuleTypes'
import {
    type Dispatch,
    type SetStateAction,
    useEffect,
    useState,
} from 'react'
import {PublicAdsApi} from '../../PublicAdsApi'
import {AdCategoryFiltersDynamicInputs} from './AdCategoryFiltersDynamicInputs'

interface ItemsCategoryPropertyFiltersProps {
    categoryId?: number | null
    filters: ItemsCategoryPropertyFiltersFormValues
    setFilters: Dispatch<SetStateAction<ItemsCategoryPropertyFiltersFormValues>>
    isSubmitting: boolean
}

// Набор фильтров по свойствам объявлений.
export function ItemsCategoryPropertyFilters(
    props: ItemsCategoryPropertyFiltersProps
) {

    const {
        categoryId,
        filters,
        setFilters,
        isSubmitting,
    } = props

    // Свойства.
    const [
        adPropertiesConfigs,
        setAdPropertiesConfigs,
    ] = useState<AdPropertyConfigForFilters[]>([])

    // Загрузка настроек динамических свойств объявлений.
    useEffect(() => {
        if (categoryId) {
            PublicAdsApi.getCategoryAdPropertiesForFilters(categoryId)
                .then(setAdPropertiesConfigs)
                .catch(() => {
                    // Игнорируем.
                })
        } else {
            setAdPropertiesConfigs([])
        }
    }, [categoryId])

    // Поля ввода.
    return (
        <AdCategoryFiltersDynamicInputs
            configs={adPropertiesConfigs}
            values={filters.props ?? {}}
            disabled={isSubmitting}
            onChange={setter => {
                setFilters(filters => ({
                    ...filters,
                    props: setter(filters.props ?? {}),
                }))
            }}
        />
    )
}
